export type EncounterColor = 'Green' | 'Blue' | 'Yellow' | 'Red';

export const ENCOUNTER_COLORS: Record<EncounterColor, { fill: string; rank: number }> = {
  Green: { fill: '#41b76b', rank: 1 }, Blue: { fill: '#489bea', rank: 2 },
  Yellow: { fill: '#f5d449', rank: 3 }, Red: { fill: '#e55750', rank: 4 },
};

// Printed world colors, copied from GameManager.CreateGameState.OtherWorldColors.
export const OTHER_WORLD_COLORS: Readonly<Record<string, readonly EncounterColor[]>> = {
  AnotherDimension: ['Green', 'Blue', 'Yellow', 'Red'],
  Abyss: ['Blue', 'Red'], CityOfTheGreatRace: ['Green', 'Yellow'],
  GreatHallOfCeleano: ['Green', 'Blue'], Yuggoth: ['Blue', 'Yellow'],
  PlateauOfLeng: ['Green', 'Red'], Rlyeh: ['Yellow', 'Red'],
  Dreamlands: ['Green', 'Blue', 'Yellow', 'Red'], UnknownKadath: ['Yellow', 'Red'],
  TheUnderworld: ['Green', 'Blue'], LostCarcosa: ['Blue', 'Yellow'], AnotherTime: ['Green', 'Red'],
};

const EXPLANATIONS: Record<string, string> = {
  'Green,Blue': 'Only green and blue encounters; these are the two easiest encounter colors.',
  'Green,Yellow': 'Green encounters offer easier possibilities, while yellow encounters bring greater danger.',
  'Green,Red': 'A sharply varied mix: the easiest green encounters and the most dangerous red encounters.',
  'Blue,Yellow': 'Blue and yellow encounters offer a mix of lower and higher danger, without the easiest green encounters.',
  'Blue,Red': 'Red encounters bring the greatest danger, with blue encounters offering some relief; there are no easy green encounters.',
  'Yellow,Red': 'Only yellow and red encounters; every encounter comes from the two most dangerous colors.',
  'Green,Blue,Yellow,Red': 'All four encounter colors are possible, ranging from the easiest green to the most dangerous red encounters.',
};

export function otherWorldInfo(name: string) {
  const colors = OTHER_WORLD_COLORS[name.replace(/ [12]$/, '')];
  if (!colors) return undefined;
  const mean = colors.reduce((sum, color) => sum + ENCOUNTER_COLORS[color].rank, 0) / colors.length;
  const danger = mean <= 1.5 ? 'Low' : mean <= 2 ? 'Moderate' : mean <= 2.5 ? 'High' : mean <= 3 ? 'Very high' : 'Maximum';
  return { colors, danger, description: EXPLANATIONS[colors.join(',')] };
}
